<template>
  <div class="wrapper">
    <img src="@/assets/brief/logo2.png" class="logo">
    <ul class="content">
      <li class="name">{{list.hspName}}</li>
      <li class="grade">
        <span v-for="it in list.slogan" :key="it">{{it}}</span>
      </li>
      <li class="phone_area">
        <span style="margin-bottom: 14px;">
          <img src="@/assets/brief/phone2.png">
          <span>{{list.phone}}</span>
          <a class="callphone" @click.stop="clear(list.phone)" >
            <van-icon name="phone-o" />
          </a>
        </span>
        <span>
          <img src="@/assets/brief/area.png">
          <span>{{list.address}}</span>
          <a class="callphone" @click.stop="clear2(list.hspCode)" >
            <van-icon name="location-o" />
          </a>
        </span>
        <!-- <a :href="'tel:0668-2102097'+list.phone" class="callphone">
          <img src="@/assets/brief/phone1.png">
        </a> -->
      </li>
      <li class="details">
        <p>院区简介</p>
        <span>{{list.descrip}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: {}
    };
  },
  created() {
    this.list = JSON.parse(sessionStorage.getItem("YardDetails"));
  },
  methods: {
    clear(phone){
      window.location.href = `tel://${phone}`;
    },
    clear2(hspCode){
      this.$router.push(`/CollegesDepartments?${hspCode}`);
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .logo{
    width: 375px;
    height: 313px;
  }
  .content{
    padding: 25px;
    display: flex;
    flex-flow: column nowrap;
    letter-spacing: 1px;
    .name{
      font-size: 17px;
      font-weight: bold;
    }
    .grade{
      margin: 14px 0px 22px;
      font-size: 14px;
      >span{
        color: #2A9DCE;
        margin-right: 4px;
        padding: 3px 7px;
        border: 1px solid #2A9DCE;
        border-radius: 3px;
      }
    }
    .phone_area{
      position: relative;
      display: flex;
      flex-flow: column nowrap;
      font-size: 14px;
      color: #BEBEBE;
      border-bottom: 1px solid #C2C2C2;
      padding-bottom: 10px;
      >span{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        >img{
          width: 17px;
          height: 20px;
        }
        >span{
          margin-left: 6px;
        }
        .callphone {
          position: absolute;
          right: 0px;
          background: #2a9dce;
          color: #FFF;
          font-size: 20px;
          border-radius: 50%;
          padding: 4px 2px 0px 4px;
        }
      }
      // .callphone{
      //   position: absolute;
      //   top: -7px;
      //   right: 0px;
      //   width: 32px;
      //   height: 32px;
      //   >img{
      //     width: 32px;
      //     height: 32px;
      //   }
      // }
    }
    .details{
      >p{
        font-size: 17px;
        margin: 24px 0px 14px;
        font-weight: 600;
      }
      >span{
        line-height: 25px;
        font-size: 14px;
        color: #707070;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/YardBrief/YardDetails.vue